export const VideoSliderData = angular
    .module('vln.videoSlider.videoSliderData', [])
    .constant('videoSliderData', {
        videos: {
            themes: {
                link: 'https://fast.wistia.net/embed/iframe/r9rc404gxc',
                title: 'VIDEOSLIDER.THEMES_TITLE',
                text: 'VIDEOSLIDER.THEMES_TEXT'
            },
            logo: {
                link: 'https://fast.wistia.net/embed/iframe/5hcygxcjo4',
                title: 'VIDEOSLIDER.LOGO_TITLE',
                text: 'VIDEOSLIDER.LOGO_TEXT'
            },
            products: {
                link: 'https://fast.wistia.net/embed/iframe/vjoqm3rle7',
                title: 'VIDEOSLIDER.PRODUCTS_TITLE',
                text: 'VIDEOSLIDER.PRODUCTS_TEXT'
            },
            categories: {
                link: 'https://fast.wistia.net/embed/iframe/jp1le6fnwz',
                title: 'VIDEOSLIDER.CATEGORIES_TITLE',
                text: 'VIDEOSLIDER.CATEGORIES_TEXT'
            },
            pages: {
                link: 'https://fast.wistia.net/embed/iframe/z8flvgf0hy',
                title: 'VIDEOSLIDER.PAGES_TITLE',
                text: 'VIDEOSLIDER.PAGES_TEXT'
            },
            settings: {
                link: 'https://fast.wistia.net/embed/iframe/xeb5wxz6p4',
                title: 'VIDEOSLIDER.SETTINGS_TITLE',
                text: 'VIDEOSLIDER.SETTINGS_TEXT'
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/videoSlider/videoSlider.data.js